import { createPortal } from 'react-dom';

/**
 * Utility functions for modal management
 */

/**
 * Adds the modal-open class to the body element
 */
export const lockBodyScroll = () => {
  document.body.classList.add('modal-open');
};

/**
 * Removes the modal-open class from the body element
 */
export const unlockBodyScroll = () => {
  document.body.classList.remove('modal-open');
};

/**
 * Ensures modals are rendered at the root level of the DOM
 * and manages body scroll locking
 * 
 * @param {boolean} isOpen - Whether the modal is open
 * @param {React.ReactNode} modalContent - The modal content to render
 * @returns {React.ReactNode|null} - The portal or null if modal is closed
 */
export const renderModalPortal = (isOpen, modalContent) => {
  if (isOpen) {
    lockBodyScroll();
    return createPortal(modalContent, document.body);
  } else {
    unlockBodyScroll();
    return null;
  }
}; 